/* eslint-disable @angular-eslint/no-inputs-metadata-property */
import { Component, Injector, inject, ChangeDetectionStrategy, output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from '@openng/optimus-ui/autocomplete';
import { NEVER, merge } from 'rxjs';
import { ControlValueAccessorConnectorComponent } from '../control-value-accessor.connector';
import {
  AutoCompleteFormControlDirective,
  AutoCompleteFormControlDirectiveInputs,
} from '../directives/autocomplete-form-control.directive';
import { BaseFormControlDirective, BaseFormControlDirectiveInputs } from '../directives/base-form-control.directive';
import {
  SelectFormControlDirective,
  SelectFormControlDirectiveInputs,
} from '../directives/select-form-control.directive';
import { FormComponent } from '../form/form.component';
import { FormConnectorService } from '../forms.utils';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';
import { uniqueId } from '@shared/utils';

@Component({
  selector: 'ui-autocomplete',
  templateUrl: './autocomplete.component.html',
  // vzhled (pole, chyba, overlay, tlačítko pro smazání) nese gov-theme (autocomplete.css), chybu libs/shared/ui/validace.css
  host: { class: 'block mb-4' },
  imports: [InputWrapperComponent, AutoCompleteModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: AutocompleteComponent,
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [
    {
      directive: BaseFormControlDirective,
      inputs: BaseFormControlDirectiveInputs,
    },
    {
      directive: SelectFormControlDirective,
      inputs: SelectFormControlDirectiveInputs,
    },
    {
      directive: AutoCompleteFormControlDirective,
      inputs: AutoCompleteFormControlDirectiveInputs,
    },
  ],
})
export class AutocompleteComponent extends ControlValueAccessorConnectorComponent {
  protected _form = inject(FormComponent, { optional: true, skipSelf: true });
  protected _formConnectorService = inject(FormConnectorService, { optional: true, skipSelf: true });
  readonly handleAction = output<AutoCompleteCompleteEvent>();

  readonly handleChange = output<any>();

  base = inject(BaseFormControlDirective);
  select = inject(SelectFormControlDirective);
  autoComplete = inject(AutoCompleteFormControlDirective);
  submitted = false;

  randomInputId = uniqueId();
  readonly MAX_OPTIONS_LENGTH = 10;

  constructor() {
    const injector = inject(Injector);

    super(injector);
    merge<boolean[]>(this._formConnectorService?.submitted$ ?? NEVER, this._form?.getSubmitted() ?? NEVER)
      .pipe(takeUntilDestroyed())
      .subscribe((_) => (this.submitted = _));
  }

  onClearHandler() {
    this.handleChange.emit(null);
  }
}
